var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable max-len */
import React from "react";
import BaseSvgIcon from "./Base";
var GeoArrow = function (props) {
    return (React.createElement(BaseSvgIcon, __assign({ viewBox: "0 0 13 13" }, props),
        React.createElement("g", null,
            React.createElement("polygon", { points: "0.5,6.100000381469727 10.5,0.5 5.90000057220459,12.500000953674316 5.5,6.5 " }))));
};
export default GeoArrow;
